import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ContentfulVue from 'contentful-vue';
import VueMarkdown from 'vue-markdown'
import VueSVGIcon from 'vue-svgicon'


Vue.config.productionTip = false

Vue.use(ContentfulVue, {
    space: "tdx6wp20nl7x",
    accessToken: "36b2341db0f1e38b44e59b1c8a4168ba5e0334979c5215b80be29b6dad76698b"
});

Vue.component('vue-markdown', VueMarkdown)
Vue.use(VueSVGIcon)

Vue.filter('dateFormat', function(value) {
    let date = new Date(Date.parse(value));
    return date.toDateString().slice(4);
});


Vue.config.ignoredElements = ['redoc']

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
